var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5411 0.959105C20.2472 0.665292 19.8487 0.500237 19.4331 0.500237C19.0175 0.500237 18.6189 0.665292 18.325 0.959105L10.5672 8.71699L2.80926 0.959105C2.51368 0.673618 2.11778 0.515649 1.70686 0.519219C1.29593 0.522791 0.902842 0.687616 0.612261 0.978197C0.32168 1.26878 0.156855 1.66186 0.153284 2.07279C0.149714 2.48372 0.307684 2.87961 0.59317 3.1752L9.45911 12.0411C9.75301 12.3349 10.1516 12.5 10.5672 12.5C10.9827 12.5 11.3813 12.3349 11.6752 12.0411L20.5411 3.1752C20.8349 2.88129 21 2.48273 21 2.06715C21 1.65157 20.8349 1.25301 20.5411 0.959105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/SelectArrow.b901a964ac0126e9feb3e9de2b1517ba.svg";
export { ForwardRef as ReactComponent };